import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

import failed from '@/assets/lotties/failed.json'
import { Feedback } from '@/components/Feedback/Feedback'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'
import { useCreatePersonaInquiryMutation } from '@/store/api/Persona/Persona.query'
import { useUserInfoQuery } from '@/store/api/Users/Users.query'

export const KYCVerificationFailed = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: userData, isError, isLoading } = useUserInfoQuery()

  const [createPersonaInquiry, { isLoading: isLoadingCreatePersonaInquiry }] =
    useCreatePersonaInquiryMutation()

  const handleVerifyIdentity = async () => {
    if (!userData?.id || !userData?.email) {
      return
    }

    try {
      const response = await createPersonaInquiry({
        referenceId: userData.id,
        language: userData.language,
      }).unwrap()
      window.open(response.hostedFlowUrl, 'noopener,noreferrer')
      navigate(AppRoutes.kycVerificationInProgress)
    } catch (error) {
      toast.error(t('kyc.failed.errorStarting'))
    }
  }
  return (
    <WeScreen useHeader={false} isError={isError} isLoading={isLoading}>
      <Feedback
        lottie={failed}
        lottieLoop={false}
        title={t('kyc.failed.title')}
        message={t('kyc.failed.message')}
        primaryButtontext={t('kyc.failed.retryButton')}
        onClickPrimaryButton={handleVerifyIdentity}
        isLoading={isLoadingCreatePersonaInquiry}
      />
    </WeScreen>
  )
}
